import { render } from "./tw-timer.vue?vue&type=template&id=0831d9b7"
import script from "./tw-timer.vue?vue&type=script&lang=js"
export * from "./tw-timer.vue?vue&type=script&lang=js"
script.render = render

export default script